var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, Typography } from "@mui/material";
import Stack from "@mui/material/Stack";
import { ExtraSmallFab } from "../../Shared/components/Buttons/ExtraSmallFAB";
/**
 * Dialog title that displays text and a close button
 *
 * @param title - dialog title
 * @param onClick - close function
 * @returns
 */
export const CardDialogTitle = (_a) => {
    var { onClick, title } = _a, rest = __rest(_a, ["onClick", "title"]);
    return (_jsx(DialogTitle, Object.assign({}, rest, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "h3" }, { children: title })), _jsx(ExtraSmallFab, { icon: CloseIcon, "aria-label": "close", onClick: () => onClick() })] })) })));
};
